<template>
  <div class="configurator-step-wrapper">
    <div
      class="configurator-overview-section-wrapper"
      id="overviewContentWrapper"
    >
      <div class="configurator-overview-section-row">
        <div
          class="configurator-overview-section-column"
          id="overviewDataColumn"
        >
          <div
            class="configurator-overview-section-column-paragraph"
            id="overviewPrint"
          >
            <h2 class="overview-print-dont-show">Zusammenfassung</h2>
            <h2 class="overview-print">Ihre Konfiguration</h2>
            <a
              href="#big-popup"
              id="configImageWrapperLink"
              class="open-popup-link"
              @click="setOverviewPopup(true)"
            >
              <h2 class="overview-print">Ihre neue Dusche - Beispielansicht</h2>
              <div
                class="overview-image-container"
                id="configImageWrapper"
                v-observe-visibility="changeBackgroundImage"
              >
                <img class="overview-picture" v-bind:src="srcPreview" />
                <img
                  class=""
                  id="exampleImagePartLeftBackwall"
                  v-if="!backwallsCombined"
                  :class="[usecaseClass, shapeClass]"
                  v-bind:src="srcImagePartLeftBackwall"
                  :style="{
                    'background-image': 'url(' + showerBoardBackgroundURL + ')'
                  }"
                />
                <img
                  class=""
                  id="exampleImagePartLeftBackwall"
                  v-if="backwallsCombined"
                  :class="[usecaseClass, shapeClass]"
                  v-bind:src="srcImagePartCombinedBackwall"
                  :style="{
                    'background-image': 'url(' + showerBoardBackgroundURL + ')'
                  }"
                />
                <img
                  class=""
                  id="exampleImagePartRightBackwall"
                  v-if="!backwallsCombined"
                  :class="[usecaseClass, shapeClass]"
                  v-bind:src="srcImagePartRightBackwall"
                />
                <img
                  class=""
                  id="exampleImagePartMiddleBackwall"
                  v-if="isNischendusche && !backwallsCombined"
                  :class="[usecaseClass, shapeClass]"
                  v-bind:src="srcImagePartMiddleBackwall"
                />
              </div>
            </a>
            <div
              v-if="!p_isPriceOnRequest"
              class="overviewSideColumn mobile-summary-view"
            >
              <div class="configurator-text-card " id="dreamShowerTextCard">
                <div class="configurator-text-card-headline-area">
                  <h4 class="configurator-text-card-headline">
                    Ihre individuelle Dusche
                  </h4>
                </div>
                <div class="configurator-text-card-content-area">
                  <div class="overall-wrapper">
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Langjährige Erfahrung und kompetente Arbeit dank mehr
                        als 20.000 Badsanierungen
                      </div>
                    </div>
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Fugenlose Hygiene für Ihre Dusche
                      </div>
                    </div>
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Größtes Angebot an Rückwanddekoren und –materialien
                      </div>
                    </div>
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Einzigartige Speziallösungen für Dusch- und
                        Badsanierungen
                      </div>
                    </div>
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Komplettprogramm aus einer Hand, Duschking ist
                        Vollsortimenter
                      </div>
                    </div>
                    <div class="overall-section price-section">
                      <div class="overall-section-left">
                        Preis: <span class="price">{{ p_price }}</span>
                        <span v-if="!c_isProfiMode" class="mwst"
                          >inkl. MwSt</span
                        ><span v-if="c_isProfiMode" class="mwst"
                          >zzgl. MwSt</span
                        >
                      </div>
                      <div class="overall-section-right">
                        <button
                          class="configurator-button button modal-button text-card-button brand-color"
                          id="orderwithoutConstructionButton"
                          @click="
                            sendShoppingCartEmail(),
                              addToBasket(debuggingProducts)
                          "
                        >
                          <span
                            v-show="!isExtraPriceAdded"
                            class="configurator-button-label"
                            ><i class="fal fa-cart-shopping"></i> Ohne Montage
                            bestellen</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="configurator-text-card " id="addonsTextCard">
                <div class="configurator-text-card-headline-area">
                  <h4 class="configurator-text-card-headline">
                    Sorgenloser Einbau von Experten
                  </h4>
                </div>
                <div class="configurator-text-card-content-area">
                  <div class="overall-wrapper">
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Beinhaltet Anlieferung
                      </div>
                    </div>
                    <div class="overall-section">
                      <div class="overall-section-left">
                        <i class="fal fa-check"></i>
                      </div>
                      <div class="overall-section-right">
                        Zusammenbau & Abdichtung vom Experten
                      </div>
                    </div>
                    <div class="overall-section">
                      <div class="dropdown">
                        <button
                          class="dropbtn"
                          @click="dropDownCollapsible($event)"
                        >
                          Zusätzlicher Aufpreis
                        </button>
                        <div class="dropdown-content" id="overview_dropdown">
                          <a
                            key="0"
                            ref="dropdownItem"
                            class="dropdown-item"
                            @click="dropdownElementClicked(180.0, 0)"
                          >
                            <div class="overview-dropdown-value-left">
                              3. Etage
                            </div>
                            <div class="overview-dropdown-value-right">
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[0] <= 0.0"
                              >
                                +
                              </div>
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[0] > 0.0"
                              >
                                -
                              </div>
                              <div class="overview-dropdown-value">180,00</div>
                              <div class="overview-dropdown-currency">€</div>
                            </div>
                          </a>
                          <a
                            key="1"
                            ref="dropdownItem"
                            class="dropdown-item"
                            @click="dropdownElementClicked(120.0, 1)"
                          >
                            <div class="overview-dropdown-value-left">
                              Aufmaßtermin vor Ort
                            </div>
                            <div class="overview-dropdown-value-right">
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[1] <= 0.0"
                              >
                                +
                              </div>
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[1] > 0.0"
                              >
                                -
                              </div>
                              <div class="overview-dropdown-value">120,00</div>
                              <div class="overview-dropdown-currency">€</div>
                            </div>
                          </a>
                          <a
                            key="2"
                            ref="dropdownItem"
                            class="dropdown-item"
                            @click="dropdownElementClicked(360.0, 2)"
                          >
                            <div class="overview-dropdown-value-left">
                              Demontage der alten Dusche
                            </div>
                            <div class="overview-dropdown-value-right">
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[2] <= 0.0"
                              >
                                +
                              </div>
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[2] > 0.0"
                              >
                                -
                              </div>
                              <div class="overview-dropdown-value">360,00</div>
                              <div class="overview-dropdown-currency">€</div>
                            </div>
                          </a>
                          <a
                            key="3"
                            ref="dropdownItem"
                            class="dropdown-item"
                            @click="dropdownElementClicked(35.0, 3)"
                          >
                            <div class="overview-dropdown-value-left">
                              Entsorgung
                            </div>
                            <div class="overview-dropdown-value-right">
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[3] <= 0.0"
                              >
                                +
                              </div>
                              <div
                                class="overview-dropdown-value-sign"
                                v-show="extraPrices[3] > 0.0"
                              >
                                -
                              </div>
                              <div class="overview-dropdown-value">35,00</div>
                              <div class="overview-dropdown-currency">€</div>
                            </div>
                          </a>
                          <a key="4" ref="dropdownItem" class="dropdown-item">
                            <div class="overview-dropdown-value-left">
                              Weiteres...
                            </div>
                            <div class="overview-dropdown-value-right">
                              <div
                                class="overview-dropdown-value overview-dropdown-input"
                              >
                                <input
                                  v-on:input="setExtraPrice()"
                                  type="number"
                                  v-model="extraPriceString"
                                  ref="extraPrice"
                                  name="extra_price"
                                />
                              </div>
                              <div class="overview-dropdown-input-currency">
                                €
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="overall-section price-section">
                      <div class="overall-section-left price-section-left">
                        Preis:
                        <span class="price">{{
                          getEuroPrice(extraPriceSum)
                        }}</span>
                        <span v-if="!c_isProfiMode" class="mwst"
                          >inkl. MwSt</span
                        ><span v-if="c_isProfiMode" class="mwst"
                          >zzgl. MwSt</span
                        >
                      </div>
                      <div class="overall-section-right">
                        <button
                          class="configurator-button button modal-button text-card-button brand-color overall-price-extra-button"
                          id="consultingTextCardButton"
                          @click="assignExtraPrice(), customOverviewSave()"
                        >
                          <span
                            v-show="!isExtraPriceAdded"
                            class="configurator-button-label"
                            >Hinzufügen</span
                          >
                          <span
                            v-show="isExtraPriceAdded"
                            class="configurator-button-label"
                            ><i class="fal fa-check"></i
                          ></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="configurator-text-card " id="overallpriceTextCard">
                <div class="configurator-text-card-headline-area">
                  <h4 class="configurator-text-card-headline">Gesamtpreis</h4>
                </div>
                <div class="configurator-text-card-content-area">
                  <div class="price-overall-wrapper">
                    <div class="price-overall-section">
                      <div class="price-overall-section-left">
                        Maßgefertigtes Bad
                      </div>
                      <div class="price-overall-section-right">
                        {{ p_price }}
                      </div>
                    </div>
                    <div class="price-overall-section">
                      <div class="price-overall-section-left">
                        Montagekosten
                      </div>
                      <div class="price-overall-section-right">
                        <span>{{ getEuroPrice(assemblyPriceSum) }}</span>
                      </div>
                    </div>
                    <div class="dropdown">
                      <button
                        class="dropbtn"
                        @click="dropDownCollapsible($event)"
                      >
                        Montagekosten
                      </button>
                      <div class="dropdown-content" id="overview_dropdown">
                        <a
                          key="0"
                          ref="dropdownItem"
                          class="dropdown-item"
                          @click="dropdownElementClicked(0, -1)"
                        >
                          Ohne Montage
                        </a>
                        <a
                          key="1"
                          ref="dropdownItem"
                          class="dropdown-item"
                          @click="
                            dropdownElementClicked(getInstallationPrice(), -1)
                          "
                        >
                          Mit Montage ({{ getInstallationPrice() }}€)
                        </a>
                      </div>
                    </div>
                    <div class="price-overall-section price-section">
                      <div class="price-overall-section-left">
                        (Lieferzeit ca. {{ shippingTime }} Tage)
                      </div>
                      <div class="price-overall-section-right">
                        Gesamtpreis:
                        <span class="price">{{
                          getEuroPrice(c_priceSum)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <button
                    @click="
                      sendShoppingCartEmail(), addToBasket(debuggingProducts)
                    "
                    class="configurator-button button modal-button text-card-button brand-color"
                    id="consultingTextCardButton"
                  >
                    <i class="fal fa-cart-shopping"></i>
                    <span class="configurator-button-label"
                      >In den Warenkorb</span
                    >
                  </button>
                </div>
              </div>
            </div>

            <div class="configurator-overview-data-card-wrapper-alternativebg">
              <div
                class="configurator-text-element-wrapper configurator-overview-section-column-paragraph-text"
              >
                <p id="imageNotExactWarning">
                  Die Abbildung ähnelt dem fertigen Produkt. Kleinere Details
                  können gegebenenfalls abweichen.
                </p>
                <p
                  class="configurator-text-element-text"
                  id="formerStepWarning"
                >
                  Wenn Sie zu einem vorherigen Schritt zurückkehren möchten,
                  klicken Sie auf den entsprechenden Eintrag in der
                  Datentabelle, sodass die Nachricht "Zu diesem Schritt
                  springen" erscheint. Falls Sie Änderungen durchführen, werden
                  die Eingaben in nachfolgenden Schritten möglicherweise
                  zurückgesetzt.
                </p>
              </div>
              <template v-for="(overviewElement, index) in c_overViewElements">
                <div
                  v-bind:key="index"
                  class="configurator-overview-data-card-wrapper"
                >
                  <div class="configurator-data-card" id="usecaseCard">
                    <div class="configurator-data-card-key">
                      <div class="configurator-overview-step-name">
                        {{ overviewElement.stepName }}
                      </div>
                      <i
                        class="configurator-data-card-key-icon"
                        v-bind:class="overviewElement.stepIcon"
                      ></i>
                    </div>
                    <div class="deviderline">|</div>
                    <div class="configurator-data-card-value">
                      <template
                        v-for="(stepValues,
                        index) in overviewElement.stepValues"
                      >
                        {{ stepValues }}<br v-bind:key="index" />
                      </template>
                    </div>
                    <div
                      @click="showSpecificStep(overviewElement.stepIndex)"
                      class="configurator-data-card-overlay"
                    >
                      Zu diesem Schritt springen
                      <i class="fal fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="overview-print">
              <div class="overview-print-price-text">
                Sie können diese Konfiguration für
                {{ getEuroPrice(c_priceSum) }} bestellen!
              </div>
              <div class="overview-print-information">
                Bei weiteren Fragen stehen wir Ihnen gerne jederzeit zur
                Verfügung.
              </div>
            </div>
          </div>
          <div class="configurator-overview-section-column overviewSideColumn">
            <div
              v-if="!p_isPriceOnRequest"
              class="configurator-text-card desktop-summary-view"
              id="dreamShowerTextCard"
            >
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">
                  Ihre individuelle Dusche
                </h4>
              </div>
              <div class="configurator-text-card-content-area">
                <div class="overall-wrapper">
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Langjährige Erfahrung und kompetente Arbeit dank mehr als
                      20.000 Badsanierungen
                    </div>
                  </div>
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Fugenlose Hygiene für Ihre Dusche
                    </div>
                  </div>
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Größtes Angebot an Rückwanddekoren und –materialien
                    </div>
                  </div>
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Einzigartige Speziallösungen für Dusch- und Badsanierungen
                    </div>
                  </div>
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Komplettprogramm aus einer Hand, Duschking ist
                      Vollsortimenter
                    </div>
                  </div>
                  <div class="overall-section price-section">
                    <div class="overall-section-left">
                      Preis: <span class="price">{{ p_price }}</span>
                      <span v-if="!c_isProfiMode" class="mwst">inkl. MwSt</span
                      ><span v-if="c_isProfiMode" class="mwst">zzgl. MwSt</span>
                    </div>
                    <div class="overall-section-right">
                      <button
                        class="configurator-button button modal-button text-card-button brand-color"
                        id="orderwithoutConstructionButton"
                        @click="
                          sendShoppingCartEmail(),
                            addToBasket(debuggingProducts)
                        "
                      >
                        <span
                          v-show="!isExtraPriceAdded"
                          class="configurator-button-label"
                          ><i class="fal fa-cart-shopping"></i> Ohne Montage
                          bestellen</span
                        >
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              v-if="!p_isPriceOnRequest && !c_isProfiMode"
              class="configurator-text-card desktop-summary-view"
              id="addonsTextCard"
            >
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">
                  Sorgenloser Einbau von Experten
                </h4>
              </div>
              <div class="configurator-text-card-content-area">
                <div class="overall-wrapper">
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Beinhaltet Anlieferung
                    </div>
                  </div>
                  <div class="overall-section">
                    <div class="overall-section-left">
                      <i class="fal fa-check"></i>
                    </div>
                    <div class="overall-section-right">
                      Zusammenbau & Abdichtung vom Experten
                    </div>
                  </div>
                  <div class="overall-section">
                    <div class="dropdown">
                      <button
                        class="dropbtn"
                        @click="dropDownCollapsible($event)"
                      >
                        Zusätzlicher Aufpreis
                      </button>
                      <div class="dropdown-content" id="overview_dropdown">
                        <a
                          key="0"
                          ref="dropdownItem"
                          class="dropdown-item"
                          @click="dropdownElementClicked(180.0, 0)"
                        >
                          <div class="overview-dropdown-value-left">
                            3. Etage
                          </div>
                          <div class="overview-dropdown-value-right">
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[0] <= 0.0"
                            >
                              +
                            </div>
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[0] > 0.0"
                            >
                              -
                            </div>
                            <div class="overview-dropdown-value">180,00</div>
                            <div class="overview-dropdown-currency">€</div>
                          </div>
                        </a>
                        <a
                          key="1"
                          ref="dropdownItem"
                          class="dropdown-item"
                          @click="dropdownElementClicked(120.0, 1)"
                        >
                          <div class="overview-dropdown-value-left">
                            Aufmaßtermin vor Ort
                          </div>
                          <div class="overview-dropdown-value-right">
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[1] <= 0.0"
                            >
                              +
                            </div>
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[1] > 0.0"
                            >
                              -
                            </div>
                            <div class="overview-dropdown-value">120,00</div>
                            <div class="overview-dropdown-currency">€</div>
                          </div>
                        </a>
                        <a
                          key="2"
                          ref="dropdownItem"
                          class="dropdown-item"
                          @click="dropdownElementClicked(360.0, 2)"
                        >
                          <div class="overview-dropdown-value-left">
                            Demontage der alten Dusche
                          </div>
                          <div class="overview-dropdown-value-right">
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[2] <= 0.0"
                            >
                              +
                            </div>
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[2] > 0.0"
                            >
                              -
                            </div>
                            <div class="overview-dropdown-value">360,00</div>
                            <div class="overview-dropdown-currency">€</div>
                          </div>
                        </a>
                        <a
                          key="3"
                          ref="dropdownItem"
                          class="dropdown-item"
                          @click="dropdownElementClicked(35.0, 3)"
                        >
                          <div class="overview-dropdown-value-left">
                            Entsorgung
                          </div>
                          <div class="overview-dropdown-value-right">
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[3] <= 0.0"
                            >
                              +
                            </div>
                            <div
                              class="overview-dropdown-value-sign"
                              v-show="extraPrices[3] > 0.0"
                            >
                              -
                            </div>
                            <div class="overview-dropdown-value">35,00</div>
                            <div class="overview-dropdown-currency">€</div>
                          </div>
                        </a>
                        <a key="4" ref="dropdownItem" class="dropdown-item">
                          <div class="overview-dropdown-value-left">
                            Weiteres...
                          </div>
                          <div class="overview-dropdown-value-right">
                            <div
                              class="overview-dropdown-value overview-dropdown-input"
                            >
                              <input
                                v-on:input="setExtraPrice()"
                                type="number"
                                v-model="extraPriceString"
                                ref="extraPrice"
                                name="extra_price"
                              />
                            </div>
                            <div class="overview-dropdown-input-currency">
                              €
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="overall-section price-section">
                    <div class="overall-section-left price-section-left">
                      Preis:
                      <span class="price">{{
                        getEuroPrice(extraPriceSum)
                      }}</span>
                      <span v-if="!c_isProfiMode" class="mwst">inkl. MwSt</span
                      ><span v-if="c_isProfiMode" class="mwst">zzgl. MwSt</span>
                    </div>
                    <div class="overall-section-right">
                      <button
                        class="configurator-button button modal-button text-card-button brand-color overall-price-extra-button"
                        id="consultingTextCardButton"
                        @click="assignExtraPrice(), customOverviewSave()"
                      >
                        <span
                          v-show="!isExtraPriceAdded"
                          class="configurator-button-label"
                          >Hinzufügen</span
                        >
                        <span
                          v-show="isExtraPriceAdded"
                          class="configurator-button-label"
                          ><i class="fal fa-check"></i
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div
              v-if="!p_isPriceOnRequest"
              class="configurator-text-card desktop-summary-view"
              id="overallpriceTextCard"
            >
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">Gesamtpreis</h4>
              </div>
              <div class="configurator-text-card-content-area">
                <div class="price-overall-wrapper">
                  <div class="price-overall-section">
                    <div class="price-overall-section-left">
                      Maßgefertigtes Bad
                    </div>
                    <div class="price-overall-section-right">
                      {{ p_price }}
                    </div>
                  </div>
                  <div class="price-overall-section" v-if="!c_isProfiMode">
                    <div class="price-overall-section-left">
                      Montagekosten
                    </div>
                    <div class="price-overall-section-right">
                      <span>{{ getEuroPrice(assemblyPriceSum) }}</span>
                    </div>
                  </div>
                  <div class="dropdown">
                    <button
                      class="dropbtn"
                      @click="dropDownCollapsible($event)"
                    >
                      Montagekosten
                    </button>
                    <div class="dropdown-content" id="overview_dropdown">
                      <a
                        key="0"
                        ref="dropdownItem"
                        class="dropdown-item"
                        @click="dropdownElementClicked(0, -1)"
                      >
                        Ohne Montage
                      </a>
                      <a
                        key="1"
                        ref="dropdownItem"
                        class="dropdown-item"
                        @click="
                          dropdownElementClicked(getInstallationPrice(), -1)
                        "
                      >
                        Mit Montage ({{ getInstallationPrice() }}€)
                      </a>
                    </div>
                  </div>
                  <div class="price-overall-section price-section">
                    <div class="price-overall-section-left">
                      (Lieferzeit ca. {{ shippingTime }} Tage)
                    </div>
                    <div class="price-overall-section-right">
                      Gesamtpreis:
                      <span class="price">{{ getEuroPrice(c_priceSum) }}</span>
                    </div>
                  </div>
                </div>
                <button
                  @click="
                    sendShoppingCartEmail(), addToBasket(debuggingProducts)
                  "
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="consultingTextCardButton"
                >
                  <i class="fal fa-cart-shopping"></i>
                  <span class="configurator-button-label"
                    >In den Warenkorb</span
                  >
                </button>
              </div>
            </div>
            <!-- <div class="configurator-text-card " id="addToBasketTextCard"> 
                        <div class="configurator-text-card-headline-area"> 
                            <h4 class="configurator-text-card-headline">Jetzt bestellen</h4> 
                        </div> 
                        <div class="configurator-text-card-content-area"> 
                            Bestellen Sie jetzt die angegebene Konfiguration in unserem Onlineshop. 
                            <button @click="addToBasket(debuggingProducts)" class="configurator-button button modal-button text-card-button brand-color" id="consultingTextCardButton"> 
                                <i class="fal fa-basket-shopping"></i> 
                                <span class="configurator-button-label">Konfiguration bestellen</span> 
                            </button> 
                        </div> 
                    </div> -->
            <div
              class="configurator-text-card "
              id="consultingTextCard"
              v-if="p_showAdvisory"
            >
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">
                  Beratung und Fragen
                </h4>
              </div>
              <div class="configurator-text-card-content-area">
                Gerne beraten wir Sie jederzeit persönlich – Telefonisch oder
                per E-Mail.
                <button
                  @click="setHelpVisible()"
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="consultingTextCardButton"
                >
                  <i class="fal fa-phone"></i>
                  <span class="configurator-button-label"
                    >Kontakt aufnehmen</span
                  >
                </button>
              </div>
            </div>
            <div class="configurator-text-card " id="consultingTextCard">
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">
                  Konfiguration speichern
                </h4>
              </div>
              <div class="configurator-text-card-content-area">
                Lassen Sie sich Ihre Konfiguration per Mail schicken. Sie
                erhalten außerdem eine Nummer, mit der Sie die Konfiguration
                jederzeit erneut laden können.
                <button
                  @click="setLoadSaveVisible()"
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="consultingTextCardButton"
                >
                  <i class="fal fa-envelope"></i>
                  <span class="configurator-button-label"
                    >Konfiguration speichern</span
                  >
                </button>
              </div>
            </div>
            <div
              class="configurator-text-card "
              id="consultingTextCard"
              v-if="p_showOverviewPrint"
            >
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">
                  Konfiguration ausdrucken
                </h4>
              </div>
              <div class="configurator-text-card-content-area">
                Drucken Sie Ihre Konfiguration ganz einfach aus. So können Sie
                diese für die spätere Bearbeitung bereithalten und offene
                Rückfragen mit unserem Serviceteam klären und haben den
                Konfigurationscode immer griffbereit.
                <button
                  @click="print()"
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="consultingTextCardButton"
                >
                  <i class="fal fa-print"></i>
                  <span class="configurator-button-label"
                    >Komplette Konfiguration drucken</span
                  >
                </button>
                <button
                  @click="printOnlyImage()"
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="consultingTextCardButton"
                >
                  <i class="fal fa-print"></i>
                  <span class="configurator-button-label"
                    >Nur Bild drucken</span
                  >
                </button>
              </div>
            </div>
            <div class="configurator-text-card " id="consultingTextCard">
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">CSV-Export</h4>
              </div>
              <div class="configurator-text-card-content-area">
                Hier können Sie Ihre ausgewählten Artikel als CSV-Datei
                exportieren.
                <button
                  @click="csvExport()"
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="consultingTextCardButton"
                >
                  <i class="fal fa-file-csv"></i>
                  <span class="configurator-button-label">CSV-Export</span>
                </button>
              </div>
            </div>
            <div
              class="configurator-text-card "
              id="restartTextCard"
              v-if="p_showOverviewRestart"
            >
              <div class="configurator-text-card-headline-area">
                <h4 class="configurator-text-card-headline">
                  Konfigurator neustarten
                </h4>
              </div>
              <div class="configurator-text-card-content-area">
                Sie wollen eine ganz neue Konfiguration starten? Klicken Sie auf
                diesen Button, um den Konfigurator neuzustarten.
                <button
                  @click="restart()"
                  class="configurator-button button modal-button text-card-button brand-color"
                  id="restartTextCardButton"
                >
                  <i class="fal fa-rotate-right"></i>
                  <span class="configurator-button-label"
                    >Konfigurator neustarten</span
                  >
                </button>
              </div>
            </div>
            <!-- <div class="configurator-text-card " id="consultingTextCard" v-html="getBenefitsHTML()"> 
                        
                    </div>  -->
          </div>
        </div>
      </div>
      <div
        class="configurator-overview-section-row"
        id="overviewAdditionalInfo"
      >
        <div
          id="overview-header"
          v-if="p_overviewSettings.length >= 1"
          v-html="p_overviewSettings[0].value"
        ></div>
        <div
          v-if="c_notEmptyOverviewSettings.length >= 2"
          id="configurator-overview-section-additional"
          class="configurator-overview-section-row-content"
        >
          <div
            v-for="index in c_notEmptyOverviewSettings.length - 1"
            v-bind:key="index"
            v-html="c_notEmptyOverviewSettings[index].value"
            class="configurator-overview-section-column"
          ></div>
        </div>
      </div>
    </div>
    <div v-if="isDebug">
      Folgende Produkte wurden gefunden:
      <div v-bind:key="index" v-for="(product, index) in debuggingProducts">
        {{ product.id }} |

        {{ product.foreignID }} |

        {{ product.quantity }}
      </div>
    </div>

    <div
      id="big-popup"
      @click="setOverviewPopup(false)"
      class="white-popup mfp-hide"
    >
      <div class="overview-image-container" v-observe-visibility="changeImages">
        <img class="overview-picture" v-bind:src="srcPreview" />
        <img
          class=""
          id="exampleImagePartLeftBackwall"
          v-if="!backwallsCombined"
          :class="[usecaseClass, shapeClass]"
          v-bind:src="srcImagePartLeftBackwall"
          :style="{
            'background-image': 'url(' + showerBoardBackgroundURL + ')'
          }"
        />
        <img
          class=""
          id="exampleImagePartLeftBackwall"
          v-if="backwallsCombined"
          :class="[usecaseClass, shapeClass]"
          v-bind:src="srcImagePartCombinedBackwall"
          :style="{
            'background-image': 'url(' + showerBoardBackgroundURL + ')'
          }"
        />
        <img
          class=""
          id="exampleImagePartRightBackwall"
          v-if="!backwallsCombined"
          :class="[usecaseClass, shapeClass]"
          v-bind:src="srcImagePartRightBackwall"
        />
        <img
          class=""
          id="exampleImagePartMiddleBackwall"
          v-if="isNischendusche && !backwallsCombined"
          :class="[usecaseClass, shapeClass]"
          v-bind:src="srcImagePartMiddleBackwall"
        />
      </div>
    </div>
    <component ref="mainComponent" v-bind:is="mainComponent"></component>
    <div class="exportCSVWrapper" style="visibility: hidden;">
      <download-csv
        ref="downloadCSV"
        delimiter=";"
        v-bind:data="jsonCSVData"
        v-bind:name="csvFileName"
      ></download-csv>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);
import * as magnificPopupJQuery from "../../assets/magnific-popup-1.1.0/jquery.magnific-popup.js";
const urlReadProductRest =
  process.env.URL_BACKEND + process.env.REST_PRODUCT_READ_PRODUCT;
const urlCalculateShippingTimeRest =
  process.env.URL_BACKEND + process.env.REST_PRODUCT_CALCULATE_SHIPPING_TIME;
const assemplyPricePerHour = process.env.ASSEMBLY_PRICE_PER_HOUR;
const euroFormatter = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR"
});
const shoppingCartEmail = "webshop@duschking.de";

export default {
  props: {
    p_steps: Array,
    p_overviewSettings: Array,
    p_showOverviewPrint: Boolean,
    p_showOverviewRestart: Boolean,
    p_showAdvisory: Boolean,
    p_price: String,
    p_configuratorDomain: String,
    p_isPriceOnRequest: Boolean
  },
  data() {
    return {
      output: null,
      srcPreview: this.$store.getters.findByValueName(
        "backgroundWithoutEnclosureURL"
      ).value,
      isNischendusche: false,
      isEckdusche: false,
      isWalkindusche: false,
      isAllChoosen: false,
      isFlat: false,
      overviewPopup: false,
      isFuenfeck: false,
      isViertelkreis: false,
      mainComponent: null,
      isRechteck: false,
      shapeClass: "",
      usecaseClass: "",
      backwallsCombined: false,
      srcImagePartLeftBackwall: this.$store.getters.findByValueName(
        "sideSelectionLeftURL"
      ).value,
      srcImagePartMiddleBackwall: this.$store.getters.findByValueName(
        "sideSelectionMiddleURL"
      ).value,
      srcImagePartRightBackwall: this.$store.getters.findByValueName(
        "sideSelectionRightURL"
      ).value,
      srcImagePartCombinedBackwall: this.$store.getters.findByValueName(
        "sideSelectionCombinedURL"
      ).value,
      showerBoardBackgroundURL: this.$store.getters.findByAttributeName(
        "showerBoardBackgroundURL"
      ).value,
      debuggingProducts: [],
      extraPrices: [0.0, 0.0, 0.0, 0.0, 0.0],
      extraPriceSum: 0.0,
      assemblyPricePercantage: 0.5,
      assemblyPriceSum: 0,
      shippingTime: 0,
      extraPriceString: "",
      isExtraPriceAdded: false,
      isDebug: process.env.URL_BACKEND.includes("localhost"),
      jsonCSVData: [],
      csvFileName: "Artikel_Liste.csv"
    };
  },
  computed: {
    c_priceSum: function() {
      if (this.$parent.$refs.topbar.isKPressed)
        if (this.isExtraPriceAdded)
          return (
            parseFloat(this.p_price.replace(".", "").replace(",", ".")) +
            parseFloat(this.extraPriceSum + "") +
            this.assemblyPriceSum
          );
        else
          return (
            parseFloat(this.p_price.replace(".", "").replace(",", ".")) +
            this.assemblyPriceSum
          );
      else return parseFloat(this.p_price.replace(".", "").replace(",", "."));
    },
    c_notEmptyOverviewSettings: function() {
      return this.p_overviewSettings.filter(
        overViewSetting =>
          !overViewSetting.value != null && overViewSetting.value.length > 0
      );
    },
    c_notHiddenSteps: function() {
      let tmpNotHiddenSteps = this.p_steps.filter(step => !step.isHidden);
      // TODO: Change this with ID list hidden in Main.vue
      for (let i = 0; i < tmpNotHiddenSteps.length; i++) {
        if (tmpNotHiddenSteps[i].id == 26) {
          tmpNotHiddenSteps.splice(i, 1);
          --i;
        }
      }
      return tmpNotHiddenSteps;
    },
    c_overViewElements: function() {
      let overviewElements = [];
      this.c_notHiddenSteps.forEach(element => {
        let overviewElement = {
          stepIndex: Number,
          stepName: String,
          stepIcon: String,
          stepValues: []
        };
        overviewElement.stepIndex = element.index;
        overviewElement.stepName = element.name;
        overviewElement.stepIcon = element.faIcon;
        this.$store.state.stepValues.forEach(stepValueElement => {
          if (
            element.id == stepValueElement.stepId &&
            stepValueElement.attributeVisible == 1
          ) {
            overviewElement.stepValues.push(stepValueElement.valueName);
          }
        });
        overviewElements.push(overviewElement);
      });
      return overviewElements;
    },
    c_isProfiMode: function() {
      return this.$parent.$refs.topbar.isPPressed;
    }
  },
  methods: {
    getBenefitsHTML() {
      if (this.$refs.mainComponent != undefined)
        return this.$refs.mainComponent.getBenefitsHTML();
    },
    getEuroPrice(price) {
      return euroFormatter.format(price);
    },
    assignExtraPrice() {
      if (this.isExtraPriceAdded) {
        this.isExtraPriceAdded = false;
      } else {
        if (this.extraPriceSum > 0.0) {
          this.isExtraPriceAdded = true;
        } else {
          this.isExtraPriceAdded = false;
        }
      }
    },
    dropDownCollapsible(event) {
      var collapseSection = $(event.target).siblings(".dropdown-content");
      if ($(collapseSection).css("display") === "none") {
        $(collapseSection).css("display", "block");
        $(event.target).addClass("open");
      } else {
        $(collapseSection).css("display", "none");
        $(event.target).removeClass("open");
      }
    },
    closeDropDownContent(event) {
      var collapseSection = $(event.target).parents(".dropdown-content");
      if ($(collapseSection).css("display") === "none") {
        $(collapseSection).css("display", "block");
        $(collapseSection.siblings(".dropbtn")).addClass("open");
      } else {
        $(collapseSection).css("display", "none");
        $(collapseSection.siblings(".dropbtn")).removeClass("open");
      }
    },
    calculateAssemblyPriceSum() {
      getInstallationPrice();
    },
    dropdownElementClicked(dropdownValue, index) {
      if (index < 0) {
        this.assemblyPriceSum = dropdownValue;
        // this.assemblyPricePercantage = dropdownValue;
        // this.calculateAssemblyPriceSum();
        this.customOverviewSave();
      } else {
        if (this.extraPrices[index] > 0.0) {
          Vue.set(this.extraPrices, index, 0.0);
        } else {
          Vue.set(this.extraPrices, index, dropdownValue);
        }
        this.calculateExtraPriceSum();
        if (this.isExtraPriceAdded) {
          this.customOverviewSave();
        }
      }
    },
    calculateExtraPriceSum() {
      this.extraPriceSum = 0.0;
      this.extraPrices.forEach(extraPrice => {
        this.extraPriceSum += extraPrice;
      });
      this.extraPriceSum = this.extraPriceSum.toFixed(2);
      if (this.extraPriceSum <= 0.0) {
        this.isExtraPriceAdded = false;
      }
    },
    setOverviewPopup(bool) {
      this.overviewPopup = bool;
    },
    setExtraPrice() {
      let extraPrice = parseFloat(this.extraPriceString.replace(",", "."));
      if (!isNaN(extraPrice)) {
        Vue.set(this.extraPrices, this.extraPrices.length - 1, extraPrice);
      } else {
        Vue.set(this.extraPrices, this.extraPrices.length - 1, 0.0);
      }
      this.calculateExtraPriceSum();
    },
    customOverviewLoad() {
      this.$refs.mainComponent.customOverviewLoad(this);
    },
    customOverviewSave() {
      this.$refs.mainComponent.customOverviewSave(this);
    },
    showSpecificStep(stepIndex) {
      this.$parent.showSpecificStep(stepIndex);
    },
    changeImages(isVisible) {
      this.isNischendusche = this.$store.getters.isValueFound("nischendusche");
      this.isEckdusche = this.$store.getters.isValueFound("eckdusche");
      this.isWalkindusche =
        this.$store.getters.isValueFound("walkindusche") ||
        this.$store.getters.isValueFound("walkin_dusche");
      this.isFlat = !this.$store.getters.isValueFound("sichtbar_aus_dekor");
      this.isFuenfeck = this.$store.getters.isValueFound("eigenmass_fuenfeck");
      this.isViertelkreis = this.$store.getters.isValueFound(
        "eigenmass_viertelkreis"
      );
      this.isRechteck = !this.isFuenfeck && !this.isViertelkreis;
      this.backwallsCombined = this.$store.getters.isValueFound(
        "dekor_alle_rueckwaende"
      );
      if (!this.backwallsCombined) {
        this.backwallsCombined = this.$store.getters.isValueFound(
          "dekore_wie_duschwanne"
        );
      }

      if (this.isNischendusche) {
        this.usecaseClass = "nischendusche";
      } else if (this.isEckdusche || this.isFuenfeck || this.isViertelkreis) {
        this.usecaseClass = "eckdusche";
      } else if (this.isWalkindusche) {
        this.usecaseClass = "walkindusche";
      }

      if (this.isFuenfeck) {
        this.shapeClass = "fuenfeck";
      } else if (this.isViertelkreis) {
        this.shapeClass = "viertelkreis";
      } else {
        this.shapeClass = "rechteck";
      }

      this.srcImagePartLeftBackwall = this.$store.getters.findByValueName(
        "sideSelectionLeftURL"
      ).value;
      this.srcImagePartMiddleBackwall = this.$store.getters.findByValueName(
        "sideSelectionMiddleURL"
      ).value;
      this.srcImagePartRightBackwall = this.$store.getters.findByValueName(
        "sideSelectionRightURL"
      ).value;
      this.srcImagePartCombinedBackwall = this.$store.getters.findByValueName(
        "sideSelectionCombinedURL"
      ).value;
      this.showerBoardBackgroundURL = this.$store.getters.findByAttributeName(
        "showerBoardBackgroundURL"
      ).value;
      if (
        this.$store.getters.findByValueName("backgroundWithArmatures") == ""
      ) {
        this.srcPreview = this.$store.getters.findByValueName(
          "backgroundWithoutEnclosureURL"
        ).value;
      } else {
        this.srcPreview = this.$store.getters.findByValueName(
          "backgroundWithArmatures"
        ).value;
      }

      if (
        $("#shower-enclosure")
          .find(".selected-element")
          .data("category") == "Walk In" ||
        this.srcPreview.includes("walkin_")
      ) {
        if (this.srcImagePartLeftBackwall != undefined) {
          this.srcImagePartLeftBackwall = this.srcImagePartLeftBackwall
            .replace("eckdusche/", "walkindusche/")
            .replace("nischendusche/", "walkindusche/");
        }
        if (this.srcImagePartMiddleBackwall != undefined) {
          this.srcImagePartMiddleBackwall = this.srcImagePartMiddleBackwall
            .replace("eckdusche/", "walkindusche/")
            .replace("nischendusche/", "walkindusche/");
        }
        if (this.srcImagePartRightBackwall != undefined) {
          this.srcImagePartRightBackwall = this.srcImagePartRightBackwall
            .replace("eckdusche/", "walkindusche/")
            .replace("nischendusche/", "walkindusche/");
        }
        if (this.srcImagePartCombinedBackwall != undefined) {
          this.srcImagePartCombinedBackwall = this.srcImagePartCombinedBackwall
            .replace("eckdusche/", "walkindusche/")
            .replace("nischendusche/", "walkindusche/");
        }
        this.srcPreview = this.srcPreview
          .replace("eckdusche_", "walkindusche_")
          .replace("nischendusche_", "walkindusche_");
      }
    },
    async changeBackgroundImage(isVisible) {
      if (isVisible) {
        this.changeImages(isVisible);
      }

      // Refresh the products for the basket
      await this.readProducts();
      // Workaround price is not correct, when switching between P and K
      await this.$parent.checkPrice();
      // Refresh the actual shipping time
      this.calculateShippingTime();
      // Load from Vuex
      // this.customOverviewLoad();
      // this.calculateAssemblyPriceSum();
    },
    // For Debugging
    readProducts() {
      this.debuggingProducts = [];
      this.$store.state.products.forEach(product => {
        let json = JSON.stringify({
          affectedProduct: {
            id: product.articleId.toString()
          }
        });
        axios
          .post(urlReadProductRest, json, {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json"
            }
          })
          .then(result => {
            this.debuggingProducts.push({
              name: result.data.article_name,
              foreignID: result.data.foreign_id,
              id: product.articleId.toString(),
              quantity: product.articleQuantity
            });
            this.setExportJSONCSV();
          });
      });
    },
    calculateShippingTime() {
      let products = {
        product_ids: "",
        quantities: ""
      };
      this.$store.state.products.forEach(product => {
        products.product_ids += product.articleId + ";";
        products.quantities += product.articleQuantity + ";";
      });
      products.product_ids = products.product_ids.substring(
        0,
        products.product_ids.length - 1
      );
      products.quantities = products.quantities.substring(
        0,
        products.quantities.length - 1
      );
      const json = JSON.stringify(products);
      axios
        .post(urlCalculateShippingTimeRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        })
        .then(result => {
          this.shippingTime = result.data.shipping_time;
        });
    },
    async print() {
      await this.$htmlToPaper("overviewPrint");
    },
    async printOnlyImage() {
      await this.$htmlToPaper("configImageWrapperLink");
    },
    async restart() {
      location.reload();
    },
    async csvExport() {
      await this.setExportJSONCSV();
      this.$el
        .getElementsByClassName("exportCSVWrapper")[0]
        .firstElementChild.click();
    },
    addToBasket(productNumberList) {
      this.$refs.mainComponent.addToBasket(productNumberList);
    },
    setHelpVisible() {
      this.$parent.setHelpVisibility(true);
    },
    setLoadSaveVisible() {
      this.$parent.setLoadSaveVisibility(true);
    },
    async setExportJSONCSV() {
      this.jsonCSVData = [];

      let priceCheck = await this.$parent.$refs.stepListItems[0].checkProductPrices();
      let priceSorted = await this.sortProductPrices(priceCheck.data);

      let sortedStructuredProductData = await this.sortDataStructure(
        this.debuggingProducts
      );

      let i = 0;

      sortedStructuredProductData.forEach(product => {
        this.jsonCSVData.push({
          Artikelnummer: product.foreignID,
          Artikelname: product.name.replace(";", ","),
          Anzahl: product.quantity,
          Stückpreis: euroFormatter.format(priceSorted.single_prices[i]),
          Gesamtpreis: euroFormatter.format(
            priceSorted.single_quantity_prices[i]
          )
        });
        i++;
      });
    },
    async sortDataStructure(data) {
      // Step 1: Convert the id field from string to integer
      for (let i = 0; i < data.length; i++) {
        data[i].id = parseInt(data[i].id);
      }

      // Step 2: Sort the data structure using the Array.sort method
      data.sort(function(a, b) {
        return a.id - b.id;
      });

      // Step 3: Convert the id field back to string
      for (let i = 0; i < data.length; i++) {
        data[i].id = data[i].id.toString();
      }

      return data;
    },
    async sortProductPrices(data) {
      const productIds = data.product_ids;
      const singlePrices = data.single_prices;
      const singleQuantityPrices = data.single_quantity_prices;

      const sortedData = productIds
        .map((id, index) => ({
          id,
          single_price: singlePrices[index],
          single_quantity_price: singleQuantityPrices[index]
        }))
        .sort((a, b) => a.id - b.id);

      return {
        product_ids: sortedData.map(item => item.id),
        single_prices: sortedData.map(item => item.single_price),
        single_quantity_prices: sortedData.map(
          item => item.single_quantity_price
        ),
        determined_price_sum: data.determined_price_sum
      };
    },
    isShoppingCartEmailNeeded() {
      for (let i = 0; i < this.$store.state.stepValues.length; ++i) {
        if (
          this.$store.state.stepValues[i].attributeId == -10 ||
          this.$store.state.stepValues[i].attributeId == -20 ||
          this.$store.state.stepValues[i].attributeId == -21 ||
          this.$store.state.stepValues[i].attributeId == -22 ||
          this.$store.state.stepValues[i].attributeId == -23
        ) {
          return true;
        }
      }
      return false;
    },
    checkIfDeactivatedCard() {
      return false;
    },
    sendShoppingCartEmail() {
      if (this.isShoppingCartEmailNeeded()) {
        this.$parent.sendShoppingCartEmail(shoppingCartEmail);
      }
    },
    getInstallationPrice() {
      const getSize = () => {
        let size = "";
        if (
          this.$store.getters.findByAttributeName("shape_selection_standard") !=
          ""
        ) {
          size = this.$store.getters.findByAttributeNameAndStepName(
            "concat_val",
            "formauswahl_standardmaße"
          ).value;
        } else if (
          this.$store.getters.findByAttributeNameAndStepName(
            "concat_val",
            "duschwanne_maße"
          ) != ""
        ) {
          size = this.$store.getters.findByAttributeNameAndStepName(
            "concat_val",
            "duschwanne_maße"
          ).value;
        }
        size = size.replace(/mm/g, "");
        return size;
      };
      const getType = () => {
        const combined = this.$store.getters.findByAttributeName(
          "side_selection_combined"
        );
        const left = String(
          this.$store.getters.findByAttributeName("side_selection_left").value
        );
        const right = String(
          this.$store.getters.findByAttributeName("side_selection_right").value
        );

        const decorType = String(
          this.$store.getters.findByAttributeName("shower_tray").value
        );
        if (
          !decorType.toLocaleLowerCase().includes("save".toLowerCase()) &&
          left.toLocaleLowerCase().endsWith("flat s".toLocaleLowerCase()) &&
          right.toLocaleLowerCase().endsWith("flat s".toLocaleLowerCase())
        ) {
          return "Basic";
        }
        return "Primus";
      };
      const getHoursForBasicType = size => {
        switch (size) {
          case "900;900":
          case "1000;1000":
            return 32;
          case "1200;800":
            return 40;
          case "1200;1200":
          case "1400;900":
          case "1700;800":
          case "2600;800":
            return 48;
          default:
            console.error(`Unknown size ${size} for Basic type`);
            return 48;
        }
      };
      const getHoursForPrimusType = size => {
        switch (size) {
          case "900;900":
          case "1000;1000":
            return 32;
          case "1200;800":
          case "1200;1200":
          case "1400;900":
          case "1700;800":
          case "2600;800":
            return 48;
          default:
            console.error(`Unknown size ${size} for Primus type`);
            return 48;
        }
      };
      let size = getSize();
      const type = getType();
      const hours =
        type === "Basic"
          ? getHoursForBasicType(size)
          : getHoursForPrimusType(size);
      return hours * assemplyPricePerHour;
    }
  },
  mounted() {
    $(".open-popup-link").magnificPopup({
      type: "inline",
      midClick: true,
      closeOnContentClick: true
    });

    this.mainComponent = () =>
      import(`../customer/${this.p_configuratorDomain}/Main.vue`);
    $(".overview-image-container").click(function() {
      if ($(window).width() < 768) {
        $(this).toggleClass("overview-image-container-mobile-zoom");
      }
    });
  }
};
</script>

<style language="css">
@import "../../scss/overview/style.css";
</style>



// WEBPACK FOOTER //
// src/components/configurator/Overview.vue